// test234
(234 && 0);
